import { ReactNode } from 'react';
import { MissionNameEnum } from '../../types/enums/missionName.enum';
import { QuestNameEnum } from '../../types/enums/questName.enum';

export const MissionTitleByEnumValueUpdated: Record<
  MissionNameEnum,
  {
    title: ReactNode;
    text: string | ReactNode;
    buttonText?: string;
  }
> = {
  [MissionNameEnum.EARLY_BIRD]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin font-normal text-white text-center text-uppercase">
        <span className="font-extrabold text-orange64">Early </span>
        Bird
      </p>
    ),
    text: null,
  },
  [MissionNameEnum.WEEKLY_MULTIPLIER]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin font-normal text-white text-center text-uppercase">
        <span className="font-extrabold text-orange64">Weekly </span>
        bonus
      </p>
    ),
    text: null,
  },
  [MissionNameEnum.TWITTER_FOLLOW]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin font-normal text-white text-center text-uppercase">
        <span className="font-extrabold text-orange64">Follow </span>X
      </p>
    ),
    text: <></>,
  },
  [MissionNameEnum.TELEGRAM_JOIN]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        <span className="font-extrabold text-orange64">Join </span>Telegram
      </p>
    ),
    text: <></>,
  },
  [MissionNameEnum.REFERRAL_DEPOSIT_ANY_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center uppercase">
        Get
        <span className="font-extrabold text-orange64"> Referral </span>
      </p>
    ),
    text: 'CODE AND BRIDGE ANY AMOUNT OF ozETH OR STABLECOIN',
    buttonText: 'Add code',
  },
  [MissionNameEnum.REFERRAL_DEPOSIT_MORE_THAN_1_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        GET
        <span className="font-extrabold text-orange64"> REFERRAL </span>
      </p>
    ),
    text: 'CODE AND BRIDGE MORE THAN 1 ozETH OR 3,000 ozUSD',
    buttonText: 'Add code',
  },
  [MissionNameEnum.EACH_REFERRAL_DEPOSIT_MORE_THAN_0_POINT_1_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        <span className="font-extrabold text-orange64">Invite </span>
        friends
      </p>
    ),
    text: 'AND GET 0.3X FOR EACH REFERRAL BRIDGING MORE THAN 0.1 ozETH OR 300 ozUSD STABLECOIN EQUIVALENT',
    buttonText: 'Get code',
  },
  [MissionNameEnum.DEPOSIT_ANY_AMOUNT_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        <span className="font-extrabold text-orange64">First </span>
        bridge
      </p>
    ),
    text: null,
  },
  [MissionNameEnum.MAINTAIN_PLUS_1_ETH_TO_TGE]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BALANCE
        <span className="font-extrabold text-orange64"> {'>1 ozETH'} </span>
      </p>
    ),
    text: ' ON OPENZK',
  },
  [MissionNameEnum.MAINTAIN_PLUS_3000_USDT_TO_TGE]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center ">
        BALANCE
        <span className="font-extrabold text-orange64"> {'>3,000 ozUSD'} </span>
      </p>
    ),
    text: ' ON OPENZK',
  },
  [MissionNameEnum.MAINTAIN_PLUS_5_ETH_TO_TGE]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BRIDGE
        <span className="font-extrabold text-orange64"> MORE </span>
      </p>
    ),
    text: 'TO MAINTAIN A BALANCE OF 5 ozETH ON OPENZK',
  },
  [MissionNameEnum.MAINTAIN_PLUS_15000_USDT_TO_TGE]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BRIDGE
        <span className="font-extrabold text-orange64"> MORE </span>
      </p>
    ),
    text: 'TO MAINTAIN A BALANCE OF 15,000 ozUSD ON OPENZK',
  },
  [MissionNameEnum.MAINTAIN_MORE_THAN_5_ETH_TO_TGE]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BRIDGE
        <span className="font-extrabold text-orange64"> MORE </span>
      </p>
    ),
    text: 'TO MAINTAIN A BALANCE >5 ozETH ON OPENZK',
  },
  [MissionNameEnum.MAINTAIN_MORE_THAN_15000_USDT_TO_TGE]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BRIDGE
        <span className="font-extrabold text-orange64"> MORE </span>
      </p>
    ),
    text: 'TO MAINTAIN A BALANCE >15,000 ozUSD ON OPENZK',
  },
};

export const QuestTitleByEnumValueUpdated: Partial<
  Record<QuestNameEnum, { title: ReactNode; text?: string }>
> = {
  [QuestNameEnum.BRIDGE_0_POINT_1_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BRIDGE
        <span className="font-extrabold text-orange64"> 0.1 ozETH </span>
      </p>
    ),
  },
  [QuestNameEnum.BRIDGE_1_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center">
        BRIDGE
        <span className="font-extrabold text-orange64"> 1 ozETH </span>
      </p>
    ),
  },
  [QuestNameEnum.REFERRAL_DEPOSIT_ANY_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        Invite
        <span className="font-extrabold text-orange64"> 1 Friend </span>
      </p>
    ),
    text: 'with a Referral Code who deposits any amount',
  },
  [QuestNameEnum.MORE_THAN_10_REFERRALS_DEPOSIT_ANY_ETH]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        Invite
        <span className="font-extrabold text-orange64"> {`>10 FriendS`} </span>
      </p>
    ),
    text: 'with a Referral Code who deposits any amount',
  },
  [QuestNameEnum.REACH_10000_POINTS]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        Reach
        <span className="font-extrabold text-orange64"> 10,000 Points</span>
      </p>
    ),
  },
  [QuestNameEnum.REACH_50000_POINTS]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        Reach
        <span className="font-extrabold text-orange64"> 50,000 Points</span>
      </p>
    ),
  },
  [QuestNameEnum.REACH_100000_POINTS]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        Reach
        <span className="font-extrabold text-orange64"> 100,000 Points</span>
      </p>
    ),
  },
  [QuestNameEnum.REACH_200000_POINTS]: {
    title: (
      <p className="md:text-xl text-xs md:leading-[25px] leading-[15px] font-thin text-white text-center text-uppercase">
        Reach
        <span className="font-extrabold text-orange64"> 200,000 Points</span>
      </p>
    ),
  },
};
